<template>
  <validation-observer ref="observer">
    <v-card>
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-md-caption">
          Form to be completed by VR Counselor and submitted to Extended
          Services provider when client has reached 20 percent (or less) job
          coach intervention OR 24 months of ongoing services in the same job
          AND meets criteria for stability.
        </p>
      </v-col>
    </v-card>
    <v-card class="mt-4">
      <v-col
        cols="12"
        class="white--text text-left text-caption"
        style="background-color: #2b3990; "
      >
        <span>Section 1: VR COUNSELOR INFORMATION</span>
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <validation-provider
              v-slot="{ errors }"
              name="Counselor Name"
              rules="required"
            >
              <v-text-field
                label="Counselor Name"
                v-model="counselorName"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="4">
            <validation-provider
              v-slot="{ errors }"
              name="Email"
              rules="required"
            >
              <v-text-field
                v-model="email"
                label="Email"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="4">
            <validation-provider
              v-slot="{ errors }"
              name="Phone"
              rules="required"
            >
              <v-text-field
                v-model="counselorPhone"
                label="Phone"
                :error-messages="errors"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="Client Name"
              rules="required"
            >
              <v-text-field
                v-model="item.employeeName"
                label="Client Name"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="Address"
              rules="required"
            >
              <v-text-field
                v-model="item.address"
                label="Address"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="City"
              rules="required"
            >
              <v-text-field
                v-model="item.city"
                label="City"
                :error-messages="errors"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="State"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.state"
                    label="State"
                    :error-messages="errors"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="Zipcode"
                  rules="required"
                >
                  <v-text-field
                    v-model="item.zip"
                    label="Zipcode"
                    :error-messages="errors"
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{ errors }"
              name="Phone"
              rules="required"
            >
              <v-text-field
                v-model="item.phone"
                label="Phone"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="12" md="3">
            <validation-provider
              v-slot="{}"
              name="Date of Birth"
              rules="required"
            >
              <v-menu
                ref="menu"
                v-model="birthDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="item.birthdate"
                    label="Birth Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="item.birthdate"
                  @input="birthDateMenu = false"
                >
                </v-date-picker>
              </v-menu>
            </validation-provider>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
    <v-card class="mt-4">
      <v-col
        cols="12"
        class="white--text text-left text-caption"
        style="background-color: #2b3990; "
      >
        <div class="text-md-caption">
          <b>Section 2: CLIENT EMPLOYMENT INFORMATION </b>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="employerName"
              label="Employer Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="hireDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.hireDate"
                  label="Date of Hire"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.hireDate"
                @input="hireDateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="employerAddress" label="Address">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.startDate"
                  label="Start Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.startDate"
                @input="startDateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field
              v-model="jobTitle"
              label="Job Title"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="weeklyInterventionHours"
              label="Weekly Intervention Hours from CRP"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="hourlyWage"
              label="Hourly Wage"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="benefits"
              label="Benefits"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="hoursWorkingPerWeek"
              label="Hours Working per Week"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="monthReceivedJobCoaching"
              label="Months client has received job coaching"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-card>

    <v-card class="mt-4">
      <v-col
        cols="12"
        class="white--text text-left text-caption"
        style="background-color: #2b3990; "
      >
        <div class="text-md-caption">
          <b>Section 3: CRP INFORMATION </b>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="crpName"
              label="CRP Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="contact" label="Contact"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="crpPhone" label="Phone"></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="crpEmail" label="Email"></v-text-field>
          </v-col>
          <v-col cols="12" md="12">
            <v-textarea
              v-model="additionalSupports"
              label="Additional Supports (transportation, day supports, residential, etc)"
              auto-grow
            ></v-textarea>
          </v-col>
        </v-row>
      </v-col>
    </v-card>

    <v-card class="mt-4">
      <v-col
        cols="12"
        class="white--text text-left text-caption"
        style="background-color: #2b3990; "
      >
        <div class="text-md-caption">
          <b>Section 4: STABILITY CRITERIA </b>
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="12">
            <v-checkbox
              class="text-caption"
              v-model="isChkClientFeels"
              label="Client feels that the job is satisfactory"
            ></v-checkbox>
            <v-checkbox
              class="text-caption"
              v-model="item.isChkAccording"
              label="According to employer, client is performing the job satisfactorily"
            ></v-checkbox>
            <v-checkbox
              class="text-caption"
              v-model="isChkEmplymenyOutcome"
              label="Employment outcome continues to match the employment goal and work schedule desired by the
  client and placement team"
            ></v-checkbox>
            <v-checkbox
              class="text-caption"
              v-model="isChkExtendedService"
              label="Extended Services, if needed, are confirmed and job coach is providing intervention less than 20
  percent of the time OR the client is approaching (30 days from) 24 months in employment"
              @change="
                (item.isChkOngoingIntervention = false) ||
                  (item.isChkOngoingSupport = false)
              "
            ></v-checkbox>

            <v-row class="ml-4 my-1">
              <v-expand-transition>
                <v-col
                  cols="12"
                  v-if="item.isChkExtendedService"
                  class="pa-0 mt-n6"
                >
                  <v-col cols="12">
                    <v-checkbox
                      class="text-caption"
                      v-model="isChkOngoingIntervention"
                      label="Is at less than 20% Ongoing Support Intervention"
                    ></v-checkbox>
                    <v-checkbox
                      class="text-caption"
                      v-model="isChkOngoingSupport"
                      label="Is approaching 24 months of Ongoing Support "
                    ></v-checkbox>
                  </v-col>
                </v-col>
              </v-expand-transition>
            </v-row>

            <v-checkbox
              class="text-caption"
              v-model="isChkNaturalSupports"
              label="Natural supports have been identified and put in place (if available) "
            ></v-checkbox>
            <v-checkbox
              class="text-caption"
              v-model="isChkNecesssary"
              label="Any necessary and reasonable accommodations have been addressed and documented with the
  employer and the employer understands how to accommodate the client. "
            ></v-checkbox>
            <v-checkbox
              class="text-caption"
              v-model="isChkOngoingTransportation"
              label="Ongoing transportation needs have been addressed."
            ></v-checkbox>
          </v-col>
        </v-row>

        <div class="text-md-caption">
          <p>
            <b
              >A job stability meeting was held with the client, the Employment
              Specialist/Job Coach, and the VR Counselor. All parties agree that
              the client has met the criteria for job stability, and is ready
              for transfer to extended services.
            </b>
          </p>

          <p>
            I understand that I am electronically signing this form, and I
            certify that the information on this form is correct to the best of
            my knowledge.
          </p>
        </div>

        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="item.counselorSignature"
              label="Counselor Signature: "
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.date"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.date"
                @input="dateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="item.formSentTo" label="Form 58B sent to">
            </v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="onDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.sentDate"
                  label="on (date)"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.sentDate"
                @input="onDateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="6">
            <v-menu
              ref="menu"
              v-model="anticipatedDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.extendedServicesDate"
                  label="Anticipated Date Extended Services will begin:"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.extendedServicesDate"
                @input="anticipatedDateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>

          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </validation-observer>
</template>
<script>
/* eslint-disable */
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { ValidationProvider, ValidationObserver },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      birthDateMenu: false,
      hireDateMenu: false,
      startDateMenu: false,
      onDateMenu: false,
      dateMenu: false,
      anticipatedDateMenu: false,
      userID: localStorage.getItem("userID"),
      item: {},
      step: this.currentStep,
    };
  },

  created() {
    this.populateUserInfo();
  },
  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.currentStep + 1);
    },

    prev() {
      this.$emit("clicked", this.currentStep - 1);
    },

    async addItem() {
      try {
        const response = await this.addDocument({
          data: this.item,
          pdfDocument: "confirmation-of-stability",
          employeeID: this.user._id,
        });
        console.log(response);
        localStorage.setItem('counselorName', this.counselorName);
        localStorage.setItem('email', this.email);
        localStorage.setItem('counselorPhone', this.counselorPhone);
        localStorage.setItem('employeeName', this.employeeName);
        localStorage.setItem('employerAddress', this.employerAddress);
        localStorage.setItem('jobTitle', this.jobTitle);
        localStorage.setItem('weeklyInterventionHours', this.weeklyInterventionHours);
        localStorage.setItem('hourlyWage', this.hourlyWage);
        localStorage.setItem('benefits', this.benefits);
        localStorage.setItem('hoursWorkingPerWeek', this.hoursWorkingPerWeek);
        localStorage.setItem('monthReceivedJobCoaching', this.monthReceivedJobCoaching);
        localStorage.setItem('crpName', this.crpName);
        localStorage.setItem('contact', this.contact);
        localStorage.setItem('crpPhone', this.crpPhone);
        localStorage.setItem('crpEmail', this.crpEmail);
        localStorage.setItem('additionalSupports', this.additionalSupports);
        localStorage.setItem('isChkClientFeels', this.isChkClientFeels);
        localStorage.setItem('isChkAccording', this.isChkAccording);
        localStorage.setItem('isChkEmplymenyOutcome', this.isChkEmplymenyOutcome);
        localStorage.setItem('isChkExtendedService', this.isChkExtendedService);
        localStorage.setItem('isChkOngoingIntervention', this.isChkOngoingIntervention);
        localStorage.setItem('isChkOngoingSupport', this.isChkOngoingSupport);
        localStorage.setItem('isChkNaturalSupports', this.isChkNaturalSupports);
        localStorage.setItem('isChkNecesssary', this.isChkNecesssary);
        localStorage.setItem('isChkOngoingTransportation', this.isChkOngoingTransportation);

      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {
      const {
        Name,
        Address,
        City,
        State,
        Zip,
        PhoneNumber,
        BirthDate,
      } = this.user;

      this.item.employeeName = Name;
      this.item.address = Address;
      this.item.city = City;
      this.item.state = State;
      this.item.zip = Zip;
      this.item.phone = PhoneNumber;
      this.item.birthDate = BirthDate;

      const response = await this.getDocuments(this.user._id);
      const counselorname = localStorage.getItem('counselorName');
      const cEmail = localStorage.getItem('email');
      const cphone = localStorage.getItem('counselorPhone');
      const employername = localStorage.getItem('employeeName');
      const EAddress = localStorage.getItem('employerAddress');
      const jobtitle = localStorage.getItem('jobTitle');
      const wih = localStorage.getItem('weeklyInterventionHours');
      const hw = localStorage.getItem('hourlyWage');
      const benefit = localStorage.getItem('benefits');
      const hpw = localStorage.getItem('hoursWorkingPerWeek');
      const mcjob = localStorage.getItem('monthReceivedJobCoaching');

      if (counselorname !== null) {
        this.counselorName = counselorname;
      }
      if (cEmail !== null) {
        this.email = cEmail;
      }
      if (cphone !== null) {
        this.counselorPhone = cphone;
      }
      if (employername !== null) {
        this.employeeName = employername;
      }
      if (EAddress !== null) {
        this.employerAddress = EAddress;
      }
      if (jobtitle !== null) {
        this.jobTitle = jobtitle;
      }
      if (wih !== null) {
        this.weeklyInterventionHours = wih;
      }
      if (hw !== null) {
        this.hourlyWage = hw;
      }
      if (benefit !== null) {
        this.benefits = benefit;
      }
      if (hpw !== null) {
        this.hoursWorkingPerWeek = hpw;
      }
      if (mcjob !== null) {
        this.monthReceivedJobCoaching = mcjob;
      }

      if (
        response.data.document.Documents.ConfirmationOfStability != undefined
      ) {
        let documents = this.updateCase(
          response.data.document.Documents.ConfirmationOfStability
        );

        this.item = Object.assign(
          {},
          {
            ...documents,
            birthdate: moment(documents.birthdate).format("YYYY-MM-DD"),
            hireDate: moment(documents.hireDate).format("YYYY-MM-DD"),
            startDate: moment(documents.startDate).format("YYYY-MM-DD"),
            sentDate: moment(documents.sentDate).format("YYYY-MM-DD"),
            date: moment(documents.date).format("YYYY-MM-DD"),
            extendedServicesDate: moment(documents.extendedServicesDate).format(
              "YYYY-MM-DD"
            ),
          }
        );
      }
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "confirmation-of-stability",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(pdfFile, "confirmation-of-stability.pdf", "application/pdf");
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
